// extracted by mini-css-extract-plugin
export default {"formLabel":"WIRField_formLabel__tXU9i","formInput":"WIRField_formInput__CpIOG"};